/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import {
    addCount,
    addWatch,
    bidding,
    bidHistory,
    currentBidValue,
    itemBuyNowPrice,
    itemDetails,
    itemImageList,
    itemsList,
    itemsNLP,
    messageAdd,
    messageAuthList,
    messagePublicList,
    notwon,
    placeBid,
    removeWatch,
    watchList,
    watchListItem,
    won,
    wonAddArchive,
    notWonAddArchive,
    searchItemsList,
    bidHistoryForWonAndNotWon,
    autoDebitPayment,
    autoDebitVaultList,
    itemReceiptAdd,
    preview,
    itemDetail,
    sneakPeak,
    wonAndNotWonitemsList,
    itemShopWithCard,
    exploreItemList,
    trendingnow
} from '../settings/apiconfig';
import interfaceService from './interfaceService';
import { getAppHeaders, getBuyerHeaders, getBuyersUrl, getSellerUrl } from 'shared/http';
import { isAuthorized } from 'shared/settings/auth';


class ItemsService {
    constructor() {
        this.service = interfaceService.getService();
    }

    getSneekPeakList(data) {
        return this.service.post(getBuyersUrl(sneakPeak), JSON.stringify(data),getBuyerHeaders());
    } 
    getItemsList(data) {
        return this.service.post(getSellerUrl(itemsList), JSON.stringify(data), getAppHeaders());
    } 
    getTrendingnowList(data) {
        return this.service.post(getSellerUrl(trendingnow), JSON.stringify(data), getAppHeaders());
    }
    getWonandNotWonItemsList(data) {
        return this.service.post(getSellerUrl(wonAndNotWonitemsList), JSON.stringify(data), getAppHeaders());
    } 
    getPreviewItemsList() {
        return this.service.get(getBuyersUrl(preview),  getBuyerHeaders());
    }
    getMemberItemDetail(itemId, saleId) {
        return this.service.get(getBuyersUrl(`${itemDetail}${itemId}/${saleId}`),  getBuyerHeaders());
    }

    getItemDetails(itemId, data) {
        return this.service.post(getSellerUrl(`${itemDetails}${itemId}`), JSON.stringify(data), getAppHeaders());
    }

    getItemImagesList(data) {
        return this.service.post(getSellerUrl(itemImageList), JSON.stringify(data), getAppHeaders());
    }

    itemsNLPSearch(data) {
        return this.service.post(getSellerUrl(itemsNLP), JSON.stringify(data), getAppHeaders());
    }

    getWatchList(data) {
        return this.service.post(getBuyersUrl(watchList), JSON.stringify(data), getBuyerHeaders());
    }

    getWatchListItem(data) {
        return this.service.post(getBuyersUrl(watchListItem), JSON.stringify(data), getBuyerHeaders());
    }

    addToWatch(data) {
        return this.service.post(getBuyersUrl(addWatch), JSON.stringify(data), getBuyerHeaders());
    }

    removeFromWatch(data) {
        return this.service.delete(getBuyersUrl(removeWatch), getBuyerHeaders(true, 'json', data));
    }

    getBidHistory(itemId) {
        return this.service.get(getBuyersUrl(`${bidHistory}${itemId}`), getBuyerHeaders());
    }
    ItemReceiptAdd(data) {
        return this.service.post(getBuyersUrl(itemReceiptAdd), JSON.stringify(data), getBuyerHeaders());
    }

    // itemReceiptGet = (data) => {
    //     return this.service.post(getBuyersUrl(itemReceiptGet), JSON.stringify(data), getBuyerHeaders());
    // }

    getBidHistoryForWonAndNotWon(itemId) {
        return this.service.get(getBuyersUrl(`${bidHistoryForWonAndNotWon}${itemId}`), getBuyerHeaders());
    }

    placeBid(data) {
        return this.service.post(getBuyersUrl(placeBid), JSON.stringify(data), getBuyerHeaders());
    }

    getBidding(data) {
        // return this.service.get(getBuyersUrl(`${bidding}`), getBuyerHeaders());
        return this.service.post(getBuyersUrl(bidding), JSON.stringify(data), getBuyerHeaders());
    }

    getWonItems(data) {
        return this.service.post(getBuyersUrl(`${won}`), JSON.stringify(data), getBuyerHeaders());
    }

    getNotWonItems(data) {
        return this.service.post(getBuyersUrl(`${notwon}`), JSON.stringify(data), getBuyerHeaders());
    }

    getCurrentBidValue(data) {
        return this.service.post(getBuyersUrl(currentBidValue), JSON.stringify(data), getBuyerHeaders());
    }

    getMessageList(data) {
        const url = isAuthorized() ? messageAuthList : messagePublicList;
        return this.service.post(getBuyersUrl(url), JSON.stringify(data), getBuyerHeaders(isAuthorized()));
    }

    sendMessage(data) {
        return this.service.post(getBuyersUrl(messageAdd), JSON.stringify(data), getBuyerHeaders(isAuthorized()));
    }

    addCountAPI = (itemId) => {
        return this.service.get(getSellerUrl(`${addCount}/${itemId}`), getAppHeaders());
    }

    getItemBuyNowPrice(itemId) {
        return this.service.get(getBuyersUrl(`${itemBuyNowPrice}${itemId}`), getBuyerHeaders());
    }

    addArchive(type, data) {
        return this.service.post(getBuyersUrl(type === "won" ? wonAddArchive : notWonAddArchive), JSON.stringify(data), getBuyerHeaders(isAuthorized()));
    }

    searchItemList(data) {
        return this.service.post(getSellerUrl(searchItemsList), JSON.stringify(data), getAppHeaders());
    }

    autoDebit(data) {
        return this.service.post(getBuyersUrl(autoDebitPayment), JSON.stringify(data), getBuyerHeaders());
    }

    autoDebitVaultList(data) {
        return this.service.post(getBuyersUrl(autoDebitVaultList), JSON.stringify(data), getBuyerHeaders());
    }

    getshopwithItemList(data) {
        return this.service.post(getSellerUrl(itemShopWithCard), JSON.stringify(data), getBuyerHeaders());
    }

    getExploreItemList(data) {
        return this.service.post(getSellerUrl(exploreItemList), JSON.stringify(data), getAppHeaders());
    }
}

export default new ItemsService();